'use-client'
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
/* eslint-disable @nx/enforce-module-boundaries */
import Head from 'next/head';
import { forwardRef } from 'react';
// import { AppendPageHeadTitle } from 'v4/snippets/custom-head';
import SearchEvents from 'v4/snippets/search/events';
import { SearchLayout } from 'v4/snippets/search/layout';
export default forwardRef(({ ...props }, ref) => {
  const { t } = useTranslator();
  return (
    <>
      <SearchLayout activeTab={'events'}>
        <Head>
          <title>{t('otherPage.createNearyBy') || "Create & Search for Nearby Events"}</title>
          <meta
            name="og:title"
            content="Create & Search for Nearby Events"
          />
          <meta
            name="description"
            content="Ignite your social calendar! Create and explore local events on myBridge. Whether it's gatherings, meetups, or festivities, find what's happening nearby."
          />
          <meta
            name="keywords"
            content="Calendar , Shareable online calendar, Shareable online calendar and scheduling,
            Online shared calendar for teams, Teamup Calendar for Teams, Online calendar for teams and groups, Online appointment scheduling
            "
          />
          <meta
            name="og:description"
            content="Ignite your social calendar! Create and explore local events on myBridge. Whether it's gatherings, meetups, or festivities, find what's happening nearby."
          />
           <link
          rel="canonical"
          href={`${typeof window !== 'undefined' && window.location.href}`}
        />
        </Head>
        <SearchEvents />
      </SearchLayout>
    </>
  );
});
